var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDiamond(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 144,
    height: 144,
    viewBox: "0 0 144 144",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M144 0H0V144H144V0Z",
    fill: "#D32737"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M114.42 17.8381L116.775 13.5404L119.131 17.8381C120.246 19.8701 121.918 21.5604 123.95 22.6573L128.248 25.0129L123.95 27.3686C121.918 28.4835 120.246 30.1558 119.131 32.1878L116.775 36.4855L114.42 32.1878C113.305 30.1558 111.632 28.4835 109.6 27.3686L105.303 25.0129L109.6 22.6573C111.632 21.5424 113.305 19.8701 114.42 17.8381Z",
    fill: "#00C8B7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3398 107.047L30.6954 102.749L33.0511 107.047C34.166 109.079 35.8383 110.769 37.8703 111.866L42.168 114.222L37.8703 116.577C35.8383 117.692 34.166 119.365 33.0511 121.397L30.6954 125.694L28.3398 121.397C27.2249 119.365 25.5526 117.692 23.5206 116.577L19.2229 114.222L23.5206 111.866C25.5526 110.751 27.2249 109.079 28.3398 107.047Z",
    fill: "#FFDD00"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M101.203 38.3916L36.9712 38.3017L17.0471 63.4405L68.9613 120.659L120.965 63.5664L101.203 38.3916Z",
    fill: "#FFDD00"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M34.202 41.7902L47.3289 60.7073H19.205L34.202 41.7902ZM118.718 60.7073H91.7265L104.386 42.4556L118.718 60.7073ZM89.0112 67.019H117.818L72.3418 116.919L89.6585 67.2347L89.0112 67.019ZM48.5877 67.019L64.9873 116.308L20.284 67.019H48.5877ZM83.7785 67.019L68.8174 109.96L54.5217 67.019H83.7785ZM75.0213 38.3556L100.358 38.3916L88.4178 55.6004L75.0213 38.3556ZM50.6196 55.6004L38.6076 38.3017L64.0163 38.3376L50.6196 55.6004ZM69.5188 40.4416L85.253 60.7073H53.8024L69.5366 40.4416H69.5188ZM107.281 33.2308L31.4507 33.3387L8.0022 63.0629L69.4648 130.442L130.676 62.8831L107.263 33.2128L107.281 33.2308Z",
    fill: "#00C8B7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiamond);
export default __webpack_public_path__ + "static/media/Diamond.35283300791f415e335cbd5cd1104ff2.svg";
export { ForwardRef as ReactComponent };